import { makeStyles } from 'tss-react/mui';

const useStylesIconOffsetBlock: MaterialUIStylesCallback = makeStyles()((
  theme: MainTheme, props: MaterialUIStylesProps,
): MaterialUIStyles => ({
  iconOffsetBlock: {
    '& > svg': {
      position: 'relative',
      top: props.offsetTop || 0,
      left: props.offsetLeft || 0,
    },
  },
}));

export default useStylesIconOffsetBlock;
